<div class="location-permission-dialog">
    <div class="dialog-header">
        <div class="icon-container">
            <mat-icon class="location-icon">location_on</mat-icon>
        </div>
        <h2 class="dialog-title">
            {{ 'SUBSCRIPTION_SETTINGS.LOCATION_PERMISSION_REQUIRED' | translate }}
        </h2>
    </div>

    <div class="dialog-content">
        <div class="message">
            <p class="primary-message">
                {{ 'SUBSCRIPTION_SETTINGS.LOCATION_PERMISSION_MESSAGE' | translate }}
            </p>
            <p class="secondary-message">
                {{ 'SUBSCRIPTION_SETTINGS.LOCATION_PERMISSION_BENEFITS' | translate }}
            </p>

            <!-- Show localhost warning if applicable -->
            <div *ngIf="isLocalhost" class="localhost-warning">
                <mat-icon class="warning-icon">warning</mat-icon>
                <p class="warning-text">
                    <strong>Development Mode:</strong> Location access may be blocked on localhost for security reasons.
                    Consider using IP detection or deploying to HTTPS for full location functionality.
                </p>
            </div>

            <!-- Show retry warning if approaching max retries -->
            <div *ngIf="data.retryCount && data.retryCount > 1" class="retry-warning">
                <mat-icon class="info-icon">info</mat-icon>
                <p class="retry-text">
                    <strong>Retry {{ data.retryCount }}/{{ data.maxRetries }}:</strong>
                    If location access continues to fail, we'll automatically use IP-based detection which may be less
                    accurate.
                </p>
            </div>

            <div class="permission-steps" *ngIf="!isLocalhost">
                <h4>{{ 'SUBSCRIPTION_SETTINGS.HOW_TO_ENABLE' | translate }}</h4>
                <ol>
                    <li>{{ 'SUBSCRIPTION_SETTINGS.PERMISSION_STEP_1' | translate }}</li>
                    <li>{{ 'SUBSCRIPTION_SETTINGS.PERMISSION_STEP_2' | translate }}</li>
                    <li>{{ 'SUBSCRIPTION_SETTINGS.PERMISSION_STEP_3' | translate }}</li>
                </ol>
            </div>
        </div>
    </div>
    <div class="dialog-actions">
        <button mat-stroked-button class="fallback-button" (click)="onUseFallback()">
            <mat-icon>language</mat-icon>
            {{ 'SUBSCRIPTION_SETTINGS.USE_IP_DETECTION' | translate }}
        </button>
        <button mat-raised-button class="retry-button" (click)="onRetry()" [disabled]="!canRetry">
            <mat-icon>location_on</mat-icon>
            {{ canRetry ? retryText : 'Max Retries Reached' }}
        </button>
    </div>
</div>